/** Step 3 "AI rating". */
const wizJudgEN = {
  wizJudgTitle: 'How should the AI rate candidates?',
  wizJudgSkipTitle: 'Without AI rating – contact all candidates',
  wizJudgSkipDesc:
    'For your own searches and project lists where you already picked the candidates yourself. Blocked candidates, those already contacted elsewhere and those with unclear gender stay off anyway.',
  wizJudgSkipSubtitle: 'All loaded candidates are contacted – the AI does not rate them.',
  wizJudgSkipKept:
    'Your criteria stay saved. Switch the rating back on and the AI rates with them.',
  wizJudgSubtitle:
    'Start with a template or have it created from the briefing, and adjust it for your position. Please note: the more criteria you add, the fewer candidates SAIA will be able to find for you.',
  wizJudgTemplate: 'Template',
  wizJudgTemplatePlaceholder: 'Choose template',
  wizJudgModified: 'adjusted',
  wizJudgFromBriefing: 'Create new from the briefing',
  wizJudgFromBriefingName: 'Created from the briefing',
  wizJudgFromBriefingBusy: 'SAIA is creating the criteria …',
  wizJudgFromBriefingError: 'The criteria could not be created.',
  wizJudgTemplatesLoading: 'Loading templates …',
  wizJudgTemplatesError: 'The templates could not be loaded.',
  wizJudgSave: 'Save as template',
  wizJudgSaved: 'Saved for the team',
  wizJudgSaveError: 'The template could not be saved.',
  wizJudgMust: 'Must',
  wizJudgMustHint: 'Shown or clearly likely → class A, not clearly shown → class B',
  wizJudgNice: 'Nice to have',
  wizJudgNiceHint: 'Mentioned in the explanation, does not change the class',
  wizJudgExcl: 'Exclusion',
  wizJudgExclHint: 'If one clearly applies → class C, not contacted',
  wizJudgAddCriterion: '+ Criterion',
  wizJudgCriterionPlaceholder: 'Criterion + Enter',
  wizJudgClassesTitle: 'Which candidates do we contact?',
  wizJudgClassesSubtitle:
    'The AI sorts every profile into class A, B or C: A meets the must criteria, B is not clearly shown but has no exclusion, C has an exclusion criterion that applies.',
  wizJudgClassA: 'A. Must criteria met, fits the position',
  wizJudgClassADesc: 'Shown in the profile or clearly likely from roles and experience',
  wizJudgClassB: 'B. Basically suitable, must criteria not clearly shown',
  wizJudgClassBDesc:
    'Basically fits the position, but the must criteria are not (fully) shown in the profile',
  wizJudgClassC: 'C. A no-go applies or not suitable for the position',
  wizJudgClassCDesc: 'Not contacted',
  wizJudgClassCLocked: 'Not selectable: these candidates are never contacted.',
  wizJudgTemplatesNone: 'No templates yet. Save criteria as a template to reuse them.',
  wizJudgSaveTitle: 'Save as template',
  wizJudgSaveName: 'Template name',
  wizJudgSaveTeam: 'For the team',
  wizJudgSaveOwn: 'Only for me',
  wizJudgSaveOverwrite: 'A template with this name already exists and will be overwritten.',
  wizJudgSaveCancel: 'Cancel',
  wizJudgSaveConfirm: 'Save',
  wizJudgSaveBusy: 'Saving …',
  wizJudgSaveNameEmpty: 'Please enter a name.',
  wizJudgSavedOwn: 'Saved for you only',
};
export default wizJudgEN;
